/**
 * Generic Tabs Controller
 * Usage: Any `.tabs` container with buttons using [data-tab="..."] 
 * and matching [id="..."] content panels.
 */

document.addEventListener("DOMContentLoaded", () => {
  const tabGroups = document.querySelectorAll("[data-tabs]");

  tabGroups.forEach(initTabs);
});

function initTabs(tabsContainer) {
  const buttons = tabsContainer.querySelectorAll(".tabs__button");
  const tabs = tabsContainer.querySelectorAll(".tabs__tab");

  buttons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const targetId = btn.getAttribute("data-tab");

      // Remove active from all buttons and tabs
      buttons.forEach((b) => {
        b.classList.remove("active");
        b.setAttribute("aria-selected", "false");
      });

      tabs.forEach((tab) => {
        tab.classList.remove("active");
        tab.hidden = true;
      });

      // Activate clicked button
      btn.classList.add("active");
      btn.setAttribute("aria-selected", "true");

      // Show target tab
      const targetTab = tabsContainer.querySelector(`#${targetId}`);
      if (targetTab) {
        targetTab.classList.add("active");
        targetTab.hidden = false;
      }
    });
  });
}
